import { render } from "./clothesAndHatsSpace.vue?vue&type=template&id=68c7e89e&scoped=true"
import script from "./clothesAndHatsSpace.vue?vue&type=script&lang=js"
export * from "./clothesAndHatsSpace.vue?vue&type=script&lang=js"

import "./clothesAndHatsSpace.vue?vue&type=style&index=0&id=68c7e89e&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c7e89e"]])

export default __exports__